import { animate, state, style, transition, trigger } from '@angular/animations'
import { NgTemplateOutlet } from '@angular/common'
import { Component, NgZone } from '@angular/core'
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr'
import { ToastDisplayComponent } from './toast-display'
import { ToastPayload } from './toast.service'

/** This is a “glue” component between the ngx-toastr package and {@link ToastDisplayComponent} */
@Component({
  selector: '[ftr-toast]',
  template: `
    <ftr-toast-display
      [type]="payload.type"
      [message]="message ?? ''"
      [title]="title ?? ''"
      [hideClose]="payload.hideClose ?? false"
      (closeToast)="remove()"
    >
      @if (payload.iconTemplate) {
        <ng-template #iconTemplate>
          <ng-container *ngTemplateOutlet="payload.iconTemplate" />
        </ng-template>
      }
      @if (payload.messageTemplate) {
        <ng-template #messageTemplate>
          <ng-container *ngTemplateOutlet="payload.messageTemplate; context: { $implicit: this }" />
        </ng-template>
      }
    </ftr-toast-display>
  `,
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0 })),
      state('active', style({ opacity: 1 })),
      state('removed', style({ opacity: 0 })),
      transition('inactive => active', animate('300ms ease-in')),
      transition('active => removed', animate('300ms ease-in')),
    ]),
  ],
  imports: [NgTemplateOutlet, ToastDisplayComponent],
})
export class ToastComponent extends Toast {
  // https://github.com/storybookjs/storybook/issues/23534#issuecomment-2010027034
  constructor(toastrService: ToastrService, toastPackage: ToastPackage, ngZone?: NgZone) {
    super(toastrService, toastPackage, ngZone)
  }

  get payload(): ToastPayload {
    return this.options.payload
  }
}
